<template>
    <b-button class="btn--add-coupon" :variant="variant">
      <b-icon-plus scale="1.6"></b-icon-plus>建立優惠券
    </b-button>
</template>

<script>
import { BButton, BIconPlus } from 'bootstrap-vue';

export default {
  name: 'CouponAddButton',
  components: {
    BButton,
    BIconPlus,
  },
  props: {
    variant: { type: String, default: 'primary' },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  &--add-coupon {
    display: flex;
    align-items: center;
    border: none;

    & > svg {
      margin-right: 3px;
    }
  }
}
</style>
